module.exports = __webpack_public_path__ + "static/img/10Industry-Analysis.9c9801ec.gif";